module.exports = __webpack_public_path__ + "static/media/33_plantilla_cuadrada_combo_simple_cp_gaseosas_pet_500_ccsa_y_ccso.dee7eced.png";